"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FakeAlignmentsClient {
    constructor() {
        this.themesByProvider = {};
        this.typesByProvider = new Map();
        this.providers = [];
    }
    setThemesByProvider(...themesByProvider) {
        themesByProvider.forEach((themeByProvider) => {
            const providerThemes = this.themesByProvider[themeByProvider.providerName] || [];
            providerThemes.push(...themeByProvider.themes);
            this.themesByProvider[themeByProvider.providerName] = providerThemes;
        });
    }
    setProviders(providers) {
        this.providers = providers;
    }
    setTypesForProvider(provider, types) {
        this.typesByProvider.set(provider, types);
    }
    setErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
    }
    setErrorReasons(reasons) {
        this.reasons = reasons;
    }
    getThemesByIds(ids) {
        const themes = Object.values(this.themesByProvider).flat();
        if (!ids || !ids.length) {
            return Promise.resolve(themes);
        }
        const filteredThemes = themes.filter((theme) => ids.includes(theme.id));
        return Promise.resolve(filteredThemes);
    }
    getThemeLogoSignedUploadLink(filename, contentType) {
        const newFilename = filename.replace('.', '_') +
            '_signed_link_' +
            contentType.replace('/', '_');
        const signedLinkUrl = `http://www.server.com/${newFilename}`;
        return new Promise((resolve) => resolve(signedLinkUrl));
    }
    getThemesByProvider(provider) {
        const themes = this.themesByProvider[provider] || [];
        return Promise.resolve(themes);
    }
    uploadThemeMapping(_themeMapping) {
        return this.errorMessage
            ? Promise.reject({ message: this.errorMessage, reasons: this.reasons })
            : Promise.resolve({ message: 'Data has been successfully imported!' });
    }
    clear() {
        this.themesByProvider = {};
    }
    updateTheme(theme, provider, title, type, logoFilename) {
        const themeToUpdate = Object.values(this.themesByProvider)
            .flat()
            .find((theme) => theme.id === theme.id);
        if (themeToUpdate === undefined) {
            return Promise.reject(`Theme not found with id: ${theme.id}`);
        }
        if (provider.trim()) {
            themeToUpdate.provider = provider.trim();
        }
        if (title.trim()) {
            themeToUpdate.title = title.trim();
        }
        if (type.trim()) {
            themeToUpdate.type = type.trim();
        }
        if (logoFilename.trim()) {
            themeToUpdate.logoUrl = 'https://image.com/' + logoFilename.trim();
        }
        return Promise.resolve();
    }
    getAllProviders() {
        return Promise.resolve(this.providers);
    }
    getThemeByProviderAndId(provider, id) {
        const themes = Object.values(this.themesByProvider).flat();
        const foundTheme = themes.find((theme) => theme.provider === provider && theme.id === id);
        if (foundTheme === undefined) {
            return Promise.reject(`Theme not found with id: ${id} and provider: ${provider}`);
        }
        return Promise.resolve(foundTheme);
    }
    deleteThemeById(theme) {
        const themes = Object.values(this.themesByProvider[theme.provider]);
        const themeIndex = themes.findIndex((t) => t.id === theme.id);
        if (themeIndex === -1) {
            return Promise.reject(`Theme not found with id: ${theme.id}`);
        }
        themes.splice(themeIndex, 1);
        this.themesByProvider[theme.provider] = themes;
        return Promise.resolve();
    }
    updateProvider(providerToUpdate, updateRequest) {
        const providerIndex = this.providers.findIndex((p) => p.id === providerToUpdate.id);
        if (providerIndex !== -1) {
            const updated = {
                ...this.providers[providerIndex],
                hidden: updateRequest.hidden,
            };
            this.providers[providerIndex] = updated;
            return Promise.resolve(updated);
        }
        else {
            return Promise.reject('Not found');
        }
    }
    renameProviderType(provider, request) {
        const providerIndex = this.providers.findIndex((p) => p.id === provider.id);
        if (providerIndex !== -1) {
            const updated = {
                ...this.providers[providerIndex],
                types: this.providers[providerIndex].types.map((type) => type === request.oldType ? request.newType : type),
            };
            this.providers[providerIndex] = updated;
            return Promise.resolve(updated);
        }
        else {
            return Promise.reject('Not found');
        }
    }
    getProviderById(id) {
        const providerIndex = this.providers.findIndex((p) => p.id === id);
        if (providerIndex !== -1) {
            return Promise.resolve(this.providers[providerIndex]);
        }
        else {
            return Promise.reject('Not found');
        }
    }
    async createProvider(request) {
        const newProvider = {
            id: request.name + Date.now(),
            ...request,
        };
        this.providers.push(newProvider);
        return Promise.resolve(newProvider);
    }
}
exports.default = FakeAlignmentsClient;
//# sourceMappingURL=FakeAlignmentsClient.js.map